module.exports = __webpack_public_path__ + "img/famille.f8480a35.jpeg";